import { NoteDetailFormValue } from '../../../../coaching-note/note-detail-form-value.model';
import {
    CmpsFormField,
    CmpsFormFields,
} from '../../../../coaching-observation/experimental.form';

export interface NarrativeCommitmentFormFields extends CmpsFormFields {
    CREATED_BY: CmpsFormField;
    DATE: CmpsFormField;
    CONTEXT: CmpsFormField;
    NOTES: CmpsFormField;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NarrativeCommitmentFormFields: NarrativeCommitmentFormFields = {
    CREATED_BY: {
        name: 'observer',
        label: 'Observer',
    },
    DATE: {
        name: 'date',
        label: 'Date',
    },
    CONTEXT: {
        name: 'context',
        label: 'Context',
    },
    NOTES: {
        name: 'note',
        label: 'Note',
    },
};

export interface NoteFormGroupValue {
    value: NoteDetailFormValue[];
}

export interface NarrativeCommitmentFormValue {
    createdBy: string;
    date: Date;
    context: string;
    notes: NoteFormGroupValue;
}
